<template>
	<div>
		<el-row :gutter="40">
			<el-col :span="12">
		   		<p>На этой странице можно импортировать предметы в Вашу коллекцию.</p>
				<el-form :model="form" :rules="rules" ref="form">
		          	<el-form-item label="Модификация" prop="mod">
		            	<el-select v-model="form.mod" style="width: 100%;">
					    	<el-option v-for="item in filters" :value="item.value" :label="item.label"></el-option>
					  	</el-select>
		          	</el-form-item>
		          	<el-form-item label="JSON" prop="file">
		            	<el-input v-model="form.file" :autosize="{ minRows: 2, maxRows: 10}" type="textarea"></el-input>
		          	</el-form-item>
		          	<el-form-item v-if="uid == 'LNgKWoXVvpS9bKKEUKzNJ4HX3sk1'" label="Тип импорта" prop="type">
						<div style="clear: left;"><el-switch v-model="form.type" active-text="В личную коллекцию" inactive-text="В базу данных" active-value="userCollection" inactive-value="itemCollection" active-color="#13ce66" inactive-color="#409EFF"></el-switch></div>
					</el-form-item>
		          	<el-form-item v-if="uid == 'LNgKWoXVvpS9bKKEUKzNJ4HX3sk1'" label="Тип записи" prop="entryType">
						<div style="clear: left;"><el-switch v-model="form.entryType" active-text="Set" inactive-text="Update" active-value="set" inactive-value="update" active-color="#13ce66" inactive-color="#409EFF"></el-switch></div>
					</el-form-item>
		          	<el-form-item>
		            	<el-button type="primary" @click="submitForm('form')">Импортировать</el-button>
		          	</el-form-item>
		          	<canvas id="canvas" height="16" width="16" style="display: none;"></canvas>
		        </el-form>
		   	</el-col>
		</el-row>
		<hr>
		<el-row :gutter="40">
			<el-col :span="12">
				<p>На этой странице можно импортировать предметы в Вашу коллекцию. Для этого выберите интересующую Вас модификацию, вставьте в текстовую область массив с объектами предметов в формате JSON, полученный при экспорте предметов. Эта страница является обратной странице "Экспорта предметов".</p>
	   			<p><b>Важно: при импорте предметов модификации Вашей коллекции будут перезаписаны, это приведёт к утрате настроек предметов, входящих в перезаписанные модификации. Рекомендуется перед импортом предметов сделать экспорт текущих предметов, если они представляют ценность, чтобы по ним можно было восстановить прежние настройки.</b></p>
	   		</el-col>
	   	</el-row>
	</div>   			
</template>

<script>

import {db, storage} from '../firebase.js';
import {modsList} from '../functions.js';

export default {
	data() {
      	return {
      		filters: [],
        	form:{
	          	file: '',
	          	mod: '',
	          	type: 'userCollection',
	          	entryType: 'update',
        	},
          	rules: {
            	mod: [
	              	{required: true, message: 'Это поле обязательно для заполнения', trigger: 'blur',},
            	],
            	file: [
	              	{required: true, message: 'Это поле обязательно для заполнения', trigger: 'blur',},
            	],
          	},
      	}
	},
	computed: {
		uid() {
			var self = this;
			var user = self.$store.state.user;
			return (user) ? user.uid : null;
		},
	},
	mounted() {
		var self = this;
		self.filters = [];
		// self.filters = self.$store.state.filters;
  		self.filters = self.filters.concat(self.$store.state.filters);
		self.filters.push({label: 'Все модификации', text: 'Все модификации', value: 'all'});
		self.$store.subscribe((mutation, state) => {
	      	switch(mutation.type) {
	        	case 'updateFilters':
	        		self.filters = [];
	        		// self.filters = self.$store.state.filters;
	        		self.filters.push({label: 'Все модификации', text: 'Все модификации', value: 'all'});
	        		self.filters = self.filters.concat(self.$store.state.filters);
	        	break;
	      	};
	    });
	    if (self.$route.params.method == 'setPowerCraftSettings') {
        	self.setPowerCraftSettings();
	    };
	},    
	methods: {
		setPowerCraftSettings(){
			var self = this;
			// var url = 'https://firebasestorage.googleapis.com/v0/b/elements-239920.appspot.com/o/uploads%2F2019%2F09%2FpowerCraftSettings.json?alt=media&token=69c6272c-e7e9-4f4b-b0cf-a0c1a3e9d5c2';
			// var url = 'http://localhost:8080/json/powerCraftSettings.json';
			var url = 'https://elements-239920.firebaseapp.com/json/powerCraftSettings.json';
			self.getJSON(url, function(err, data) {
			  	if (err !== null) {
			    	// console.log(err);
			  	} else {
			    	// console.log(data);
			    	self.form.mod = 'all';
			    	// self.form.file = data;
			    	self.form.file = JSON.stringify(data, null, 2);
					self.submitForm('form');
			        self.$router.push({
			          	name: 'items',
			        });
			  	};
			});
		},
		getJSON(url, callback) {
		    var xhr = new XMLHttpRequest();
		    xhr.open('GET', url, true);
		    xhr.responseType = 'json';
		    xhr.onload = function() {
		      var status = xhr.status;
		      if (status === 200) {
		        callback(null, xhr.response);
		      } else {
		        callback(status, xhr.response);
		      }
		    };
		    xhr.send();
		},
		submitForm(formName) {
			var self = this;
	        this.$refs[formName].validate((valid) => {
	          	if (valid) {
	          		try {
	            		var json = JSON.parse(self.form.file);
	            	} catch (e) {
	            		self.$notify({title: 'Ошибка', message: 'В структуре вашего JSON ошибка, поправьте её и попробуйте ещё раз. Для поиска ошибки можете воспользоваться эти ресурсом https://jsonformatter.curiousconcept.com/ либо другим аналогичным.', type: 'error', duration: 10000});
	            	};
	            	var datas = {};
	            	var data = {};
	            	// var items = [];
	            	// var mods = [];
        			var canvas = document.getElementById('canvas');
        			var ctx = canvas.getContext('2d');
	            	var size = 0;
	            	var nameList = json.map(el=>{
	            		var displayName = (el["Display Name"]) ? el["Display Name"] : el.displayNameRu;
	            		return displayName;
	            	});
    				var consent = false;
    				if (self.form.type == 'itemCollection') {
    					consent = confirm('База данных будет ПЕРЕПИСАНА, УБЕДИТЕСЬ что обновление происходит из файла экспорта модификации!');
    				};

		        	var hiddenMods = [];
		        	var userOptions = self.$store.state.userOptions;
		        	if (userOptions) {
				       	hiddenMods = userOptions.hiddenMods || [];
				    };
					var passiveMods = [];
	            	json.forEach(function(el){
            			if (self.form.type == 'itemCollection') {
		    				if (consent) {
								var image = new Image();
								var mod = el.mod || self.form.mod;
				        		var itemName = (el["Item Name"]) ? el["Item Name"] : el.itemName;
				        		var itemMeta = (el["Item meta"]) ? el["Item meta"] : el.itemMeta;
		        				var name = itemName + ':' + itemMeta;
								if (el.image == undefined) {
									var imageMeta = self.$store.state.itemCollection[mod].find(subEl=>{return subEl.name == name});
									el.image = (imageMeta) ? imageMeta.image : undefined;
									// console.log(el.image);
								};
			        			image.src = (el.image) ? el.image : 'http://localhost:8080/img/' + self.form.mod + '/' + el["Display Name"] + '.png';
			        			image.onload = function(){
					        		var displayNameRu = (el["Display Name"]) ? el["Display Name"] : el.displayNameRu;
			        				nameList.splice(nameList.indexOf(displayNameRu), 1);
			        				if (nameList.length < 3) {
			        					console.log(nameList);
			        				};
			        				var image;
			        				if (el.image) {
			        					image = el.image;
				        			} else {
				        				ctx.clearRect(0, 0, canvas.width, canvas.height);
				        				ctx.drawImage(this, 0, 0);
				        				image = canvas.toDataURL();
				        			};
			        				var recipe = el.recipe;
			        				if (el.recipe) {
			        				} else {
			        					var key = el.key || {};
						        		var pattern = el.pattern || false;
										pattern = (pattern[0] == "") ? false : pattern;
										key = (pattern == false) ? {} : key;
						        		for (var prop in key) {
						        			var meta = key[prop].meta;
						        			meta = (meta != undefined || meta != '') ? meta : '0';
						        			key[prop].item = key[prop].item + ':' + meta;
						        		};
						        		var count = el["count"] || 1;
						        		count = (count == '') ? 1 : count;
						        		recipe = {
						        			pattern: pattern,
							        		key: key,
							        		count: count,
						        		};
			        				};
					        		var itemID = (el["Item ID"]) ? el["Item ID"] : el.itemID;
					        		if (datas[mod] == undefined) {datas[mod] = {};};
					        		datas[mod][name] = {
						        		itemName: itemName,
							        	itemID: itemID,
							        	itemMeta: itemMeta,
							        	displayNameRu: displayNameRu,
							        	image: image,
							        	recipe: recipe,
							        	mod: mod,
							        };
							        size++;
							        // console.log(size);
							        if (size == json.length) {
							        	if (self.form.mod != 'all') {
							        		var m = datas[self.form.mod];
							        		datas = {};
							        		datas[self.form.mod] = m;
							        	};
							        	for (var prop in datas) {
							        		if (datas[prop]) {
							        			// console.log(self.form.mod, datas[prop]);
							        			// console.log(self.form.entryType);
							        			// console.log(prop);
							        			if (self.form.entryType == 'set') {
							        				db.collection('mods').doc(prop).set(datas[prop]).then(function(){	
						            					self.$notify({title: 'Успех', message: 'База предметов успешно перезаписана', type: 'success'});
						            				});
							        			} else if (self.form.entryType == 'update') {
							        				db.collection('mods').doc(prop).update(datas[prop]).then(function(){
						            					self.$notify({title: 'Успех', message: 'База предметов успешно обновлена', type: 'success'});
						            				});
							        			};
				            				};
							        	};
							        };
			        			};
					        };
						} else {
							var elSanitize = {
								count: el.count,
								key: el.key,
								pattern: el.pattern,
								customPrice: el.customPrice,
								recipePrice: el.recipePrice,
								priceType: el.priceType,
								ingredients: el.ingredients,
								price: el.price,
								item: el.item,
								mod: el.mod,
							};
							// console.log(data);
							if (data[el.mod] == undefined) {data[el.mod] = {}};
							// data[el.item] = elSanitize;
							data[el.mod][el.item] = elSanitize;
							size++;

							// console.log(el.mod);

							if (passiveMods.indexOf(el.mod) == -1 && hiddenMods.indexOf(el.mod) != -1) {
		                      	passiveMods.push(el.mod);
		                    };
		                    // var key = el.key;
		                  	for (var subProp in el.key) {
		                    	var mod = el.key[subProp].mod;
		                    	if (passiveMods.indexOf(mod) == -1 && hiddenMods.indexOf(mod) != -1) {
		                      		passiveMods.push(el.key[subProp].mod);
		                    	};
		                	};

		                	// console.log(passiveMods);

					        if (size == json.length) {
					        	if (self.form.mod != 'all') {
					        		var m = data[self.form.mod];
					        		data = {};
					        		data[self.form.mod] = m;
					        	};
					        	for (var prop in data) {
						        	(function(){
						        		var p = prop;
						        		var doc = db.collection('mods').doc(prop).collection('recipes').doc(self.uid);
			            				doc.update(data[p]).then(function(){
			            					// console.log(data[p]);
			            					self.$notify({title: 'Успех', message: 'Предметы успешно импортированы в Вашу коллекцию', type: 'success'});
			            				}).catch((error) => {
			            					data[p].rating = 0;
			            					data[p].author = self.uid;
								        	doc.set(data[p]).then(function(){
									    		self.$notify({title: 'Успех', message: 'Предметы успешно импортированы в Вашу коллекцию', type: 'success'});
											});
								    	});
		            				})();
								};

								if (passiveMods.length > 0) {
									var message = 'Предметы из модификиций ';
								    passiveMods.forEach(el=>{
								      	hiddenMods.splice(hiddenMods.indexOf(el), 1);
								      	message += modsList.find(subEl=>{return subEl.value == el}).label + ', ';
								    });
								    message.slice(-1, 2);
								    message += ' могут встречаться в рецептах Ваших предметов, поэтому их отображение было восстановлено';
								    var update = {hiddenMods: hiddenMods};
								    db.collection('users').doc(self.$store.state.user.uid).update(update).then(function(){
								      	self.$notify({title: 'Заметка', message: message, type: 'info'});
								      	passiveMods = [];
								    });
								};    

					        };
					    }; 
			        });
				       
	          	} else {
	            	return false;
	          	};
	        });
	    }
	},
};
</script>